import InfinitePop from '../pages/apps/InfinitePop';
import LiquidFlow from '../pages/apps/LiquidFlow';
import SpectrumNoise from '../pages/apps/SpectrumNoise';
import WhackALight from '../pages/apps/WhackALight';
import AnimalMeditations from '../pages/apps/AnimalMeditations';
import GravitySand from '../pages/apps/GravitySand';
import MandalaMaker from '../pages/apps/MandalaMaker';
import GalaxySpinner from '../pages/apps/GalaxySpinner';
import DigitalLavaLamp from '../pages/apps/DigitalLavaLamp';
import MoodPendulum from '../pages/apps/MoodPendulum';
import AudioRainmaker from '../pages/apps/AudioRainmaker';
import GiggleGenerator from '../pages/apps/GiggleGenerator';
import GiggleGeneratorPremium from '../pages/apps/GiggleGeneratorPremium';
import GradientSort from '../pages/apps/GradientSort';
import WorryShredder from '../pages/apps/WorryShredder';
import NeonTracer from '../pages/apps/NeonTracer';
import InfiniteMarbleRun from '../pages/apps/InfiniteMarbleRun';
import VisualBreathingBox from '../pages/apps/VisualBreathingBox';
import ShapeBreather from '../pages/apps/ShapeBreather';
import FractalBreathTree from '../pages/apps/FractalBreathTree';
import ZenFrogger from '../pages/apps/ZenFrogger';
import MindfulBlocks from '../pages/apps/MindfulBlocks';
import StrawBreathing from '../pages/apps/StrawBreathing';
import SizeStack from '../pages/apps/SizeStack';
import TameTangram from '../pages/apps/TameTangram';
import TameTangramPremium from '../pages/apps/TameTangramPremium';
import ExerciseExpert from '../pages/apps/ExerciseExpert';
import BrilliantBalancer from '../pages/apps/BrilliantBalancer';


const appConfig = [
  {
    id: 'bubble-wrap',
    name: 'Infinite Pop',
    path: '/bubble-wrap',
    category: 'visual',
    isPremium: false,
    component: InfinitePop,
    description: 'Pop endless bubbles for satisfying tactile feedback',
    color: '#FFADAD',
    icon: 'Circle'
  },
  {
    id: 'liquid',
    name: 'Liquid Flow',
    path: '/liquid',
    category: 'visual',
    isPremium: false,
    component: LiquidFlow,
    description: 'Watch particles flow like water at your touch',
    color: '#A8DADC',
    icon: 'Droplets'
  },
  {
    id: 'noise',
    name: 'Spectrum Noise',
    path: '/noise',
    category: 'auditory',
    isPremium: false,
    component: SpectrumNoise,
    description: 'White, pink, and brown noise for calm focus',
    color: '#CDB4DB',
    icon: 'Volume2'
  },
  {
    id: 'reflex',
    name: 'Whack-a-Light',
    path: '/reflex',
    category: 'active',
    isPremium: false,
    component: WhackALight,
    description: 'Test your reflexes with this engaging light game',
    color: '#B9FBC0',
    icon: 'Zap'
  },
  {
    id: 'animals',
    name: 'Bear Box Breathing',
    path: '/animals',
    category: 'breathing',
    isPremium: false,
    component: AnimalMeditations,
    description: '4-4-4-4 box breathing for calm and focus',
    color: '#FFD6A5',
    icon: 'Heart'
  },
  {
    id: 'gravity-sand',
    name: 'Gravity Sand',
    path: '/gravity-sand',
    category: 'visual',
    isPremium: false,
    component: GravitySand,
    description: 'Create mesmerizing falling sand patterns',
    color: '#F4A460',
    icon: 'Mountain'
  },
  {
    id: 'mandala',
    name: 'Mandala Maker',
    path: '/mandala',
    category: 'visual',
    isPremium: false,
    component: MandalaMaker,
    description: 'Draw beautiful radial symmetry patterns',
    color: '#DDA0DD',
    icon: 'Sparkles'
  },
  {
    id: 'galaxy',
    name: 'Galaxy Spinner',
    path: '/galaxy',
    category: 'visual',
    isPremium: false,
    component: GalaxySpinner,
    description: 'Journey through a warp speed starfield',
    color: '#4B0082',
    icon: 'Rocket'
  },
  {
    id: 'lava-lamp',
    name: 'Digital Lava Lamp',
    path: '/lava-lamp',
    category: 'visual',
    isPremium: false,
    component: DigitalLavaLamp,
    description: 'Watch hypnotic metaballs float and merge',
    color: '#FF6B9D',
    icon: 'Flame'
  },
  {
    id: 'pendulum',
    name: 'Rainbow Pendulum',
    path: '/pendulum',
    category: 'visual',
    isPremium: false,
    component: MoodPendulum,
    description: 'Chaotic beauty of double pendulum physics',
    color: '#20B2AA',
    icon: 'Orbit'
  },
  {
    id: 'audio-rainmaker',
    name: 'Audio Rainmaker',
    path: '/audio-rainmaker',
    category: 'auditory',
    isPremium: false,
    component: AudioRainmaker,
    description: 'Mix nature sounds for perfect ambient peace',
    color: '#87CEEB',
    icon: 'CloudRain'
  },
  {
    id: 'giggle-generator',
    name: 'Giggle Generator - Free',
    path: '/giggle-generator',
    category: 'cognitive',
    isPremium: false,
    component: GiggleGenerator,
    description: '31 jokes to brighten your mood',
    color: '#FFE66D',
    icon: 'Smile'
  },
  {
    id: 'giggle-generator-premium',
    name: 'Giggle Generator Premium',
    path: '/giggle-generator-premium',
    category: 'cognitive',
    isPremium: true,
    component: GiggleGeneratorPremium,
    description: '300 hilarious child-friendly jokes',
    color: '#FFB347',
    icon: 'SmilePlus'
  },
  {
    id: 'gradient-sort',
    name: 'Gradient Sort',
    path: '/gradient-sort',
    category: 'cognitive',
    isPremium: false,
    component: GradientSort,
    description: 'Satisfying color puzzle for visual clarity',
    color: '#FF6B9D',
    icon: 'Palette'
  },
  {
    id: 'worry-shredder',
    name: 'Worry Shredder',
    path: '/worry-shredder',
    category: 'cognitive',
    isPremium: false,
    component: WorryShredder,
    description: 'Write and destroy worries with animation',
    color: '#B8B8D1',
    icon: 'Trash2'
  },
  {
    id: 'zen-frogger',
    name: 'Zen Frogger',
    path: '/zen-frogger',
    category: 'cognitive',
    isPremium: false,
    component: ZenFrogger,
    description: 'Peaceful journey across lily pads and streams',
    color: '#98D8C8',
    icon: 'Turtle'
  },
  {
    id: 'mindful-blocks',
    name: 'Mindful Blocks',
    path: '/mindful-blocks',
    category: 'cognitive',
    isPremium: false,
    component: MindfulBlocks,
    description: 'Tetris-inspired calming block puzzle to assist with focus and provide a guilt free distraction for the brain',
    color: '#B4A7D6',
    icon: 'Box'
  },
  {
    id: 'neon-tracer',
    name: 'Neon Tracer',
    path: '/neon-tracer',
    category: 'active',
    isPremium: false,
    component: NeonTracer,
    description: 'Follow glowing paths with precision',
    color: '#39FF14',
    icon: 'Zap'
  },
  {
    id: 'marble-run',
    name: 'Infinite Marble Run',
    path: '/marble-run',
    category: 'visual',
    isPremium: false,
    component: InfiniteMarbleRun,
    description: 'Watch marbles flow through physics playground',
    color: '#6A5ACD',
    icon: 'Circle'
  },
  {
    id: 'breathing-box',
    name: 'Visual Breathing Box',
    path: '/breathing-box',
    category: 'breathing',
    isPremium: false,
    component: VisualBreathingBox,
    description: 'Classic 4-4-4-4 box breathing technique',
    color: '#ADD8E6',
    icon: 'Square'
  },
  {
    id: 'shape-breather',
    name: 'Shape Breather',
    path: '/shape-breather',
    category: 'breathing',
    isPremium: true,
    component: ShapeBreather,
    description: 'Expanding flower shapes sync with breath',
    color: '#FFB6C1',
    icon: 'Flower'
  },
  {
    id: 'fractal-tree',
    name: 'Fractal Breath Tree',
    path: '/fractal-tree',
    category: 'breathing',
    isPremium: true,
    component: FractalBreathTree,
    description: 'Watch a recursive tree grow with your breathing',
    color: '#90EE90',
    icon: 'TreeDeciduous'
  },
  {
    id: 'straw-breathing',
    name: 'Straw Breathing',
    path: '/straw-breathing',
    category: 'breathing',
    isPremium: false,
    component: StrawBreathing,
    description: '2-to-1 pursed-lip breathing for hyperventilation',
    color: '#81C784',
    icon: 'CupSoda'
  },
  {
    id: 'size-stack',
    name: 'Size Stack',
    path: '/size-stack',
    category: 'cognitive',
    isPremium: false,
    component: SizeStack,
    description: 'Classic Towers of Hanoi - move all discs to the right',
    color: '#7C9A82',
    icon: 'Layers'
  },
  {
    id: 'tame-tangram',
    name: 'Tame the Tangram',
    path: '/tame-tangram',
    category: 'cognitive',
    isPremium: false,
    inDevelopment: true,
    component: TameTangram,
    description: 'Create animal pictures with tangram shapes',
    color: '#FFD54F',
    icon: 'Puzzle'
  },
  {
    id: 'tame-tangram-premium',
    name: 'Tame the Tangram Premium',
    path: '/tame-tangram-premium',
    category: 'cognitive',
    isPremium: true,
    inDevelopment: true,
    component: TameTangramPremium,
    description: 'Animals, vehicles, objects & sports with context',
    color: '#FFB74D',
    icon: 'Puzzle'
  },
  {
    id: 'exercise-expert',
    name: 'Exercise Expert',
    path: '/exercise-expert',
    category: 'active',
    isPremium: false,
    component: ExerciseExpert,
    description: 'Follow stick-man exercises: star jumps, press ups & more',
    color: '#FF7043',
    icon: 'Dumbbell'
  },
  {
    id: 'brilliant-balancer',
    name: 'Brilliant Balancer',
    path: '/brilliant-balancer',
    category: 'active',
    isPremium: false,
    component: BrilliantBalancer,
    description: 'Practice balance poses with guided stick-man demos',
    color: '#42A5F5',
    icon: 'Scale'
  }
];

export default appConfig;